import React, {Component} from "react";
import Link from "gatsby-link";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import fabTwitter from "@fortawesome/fontawesome-free-brands/faTwitter";
import fabYouTube from "@fortawesome/fontawesome-free-brands/faYoutube";
import fasRss from "@fortawesome/fontawesome-free-solid/faRss";

class Footer extends Component {
  render() {
    const {config: {rssUrl}} = this.props;
    return (
      <footer className="footer">
        <div className="container">
          <div className="columns">
            <div className="column is-narrow">
              <img src="/logos/oncezone-brand.png" alt="Once Zone Logo" />
            </div>
            <div className="column">
              <p className="title is-5 has-text-white">
                Pages
              </p>
              <p>
                <Link to="/">
                  Home
                </Link>
              </p>
              <p>
                <Link to="/videos">
                  Videos
                </Link>
              </p>
              <p>
                <Link to="/posts">
                  Blog
                </Link>
              </p>
              <p>
                <Link to="/progress">
                  Progress
                </Link>
              </p>
              <p>
                <Link to="/team">
                  Team
                </Link>
              </p>
              <p>
                <Link to="/donate">
                  Donate
                </Link>
              </p>
            </div>
            <div className="column">
              <p className="title is-5 has-text-white">
                Questions?
              </p>
              <p className="has-text-white">
                Send your messages here!
              </p>
              <p>
                <a href="mailto:mainadmin@oncezone.com">
                  mainadmin@oncezone.com
                </a>
              </p>
              <p>
                <Link to="/contact">
                  Contact
                </Link>
              </p>
            </div>
            <div className="column">
              <p className="title is-5 has-text-white">
                Follow Us!
              </p>
              <a
                href="https://twitter.com/OnceZone"
                className="socialMedia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="icon is-small is-left">
                  <FontAwesomeIcon icon={fabTwitter} size="2x" />
                </span>
              </a>
              <a
                href="https://www.youtube.com/channel/UCciZqdJmIcaIqJCje0JT9fQ"
                className="socialMedia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="icon is-small is-left">
                  <FontAwesomeIcon icon={fabYouTube} size="2x" />
                </span>
              </a>
              <a
                href={rssUrl}
                className="socialMedia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="icon is-small is-left">
                  <FontAwesomeIcon icon={fasRss} size="2x" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx